import { environment } from 'src/environments/environment';
import { Component, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { ProjectItemType } from 'src/app/modules/shared/models/project/project-item-type.enum';
import { ProjectSectionItem } from 'src/app/modules/shared/models/project/project-section-item.model';
import { User } from 'src/app/modules/shared/models/staff/user.model';
import {
  EventService,
  EventType,
} from 'src/app/modules/shared/providers/event.service';
import { GlobalService } from 'src/app/modules/shared/providers/global.service';
import { OmMenuService } from 'src/app/modules/shared/services/om-menu.service';
import { ProjectSectionItemService } from 'src/app/modules/shared/services/project-section-item.service';
import {
  OrganizationType,
  OrganizationTypeMap,
} from './../../../shared/models/staff/organization-type.enum';

import { zip } from 'rxjs';
import { WorkFlowTaskSummary } from 'src/app/modules/shared/models/form/work-flow-task-summary.model';
import { WorkFlowTaskToDoType } from 'src/app/modules/shared/models/form/work-flow-task-to-do-type.enum';
import { LoginInfo } from 'src/app/modules/shared/models/login/login-info.model';
import { MenuAudit } from 'src/app/modules/shared/models/menu/menu-audit.model';
import { MenuType } from 'src/app/modules/shared/models/menu/menu-type.enum';
import { Menu } from 'src/app/modules/shared/models/menu/menu.model';
import { ProjectSectionListRequest } from 'src/app/modules/shared/models/project/project-section-list-request.model';
import { ProjectSection } from 'src/app/modules/shared/models/project/project-section.model';
import { UserPost } from 'src/app/modules/shared/models/staff/user-post.model';
import { ProjectSectionService } from 'src/app/modules/shared/services/project-section.service';
import { StaffUserService } from 'src/app/modules/shared/services/staff-user.service';
import { WorkFlowTaskService } from 'src/app/modules/shared/services/work-flow-task.service';
import { Md5 } from 'ts-md5';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
})
export class MainComponent {
  subsciption = () => this.getSummary();

  isCollapsed = false;

  openIndex = -1;

  userInfo?: User;

  postInfo?: UserPost;

  auditUrlMap: { [key: string]: MenuAudit } = {};

  fullMenuList: {
    title: string;
    icon?: string;
    open: boolean;
    children: { title: string; url: string }[];
  }[] = [];

  count = 0;

  OrganizationTypeMap = OrganizationTypeMap;

  isLogin = false;

  mit = '';

  environment = environment;

  constructor(
    private globalService: GlobalService,
    private router: Router,
    private events: EventService,
    private omMenuService: OmMenuService,
    private projectSectionItemService: ProjectSectionItemService,
    private staffUserService: StaffUserService,
    private workFlowTaskService: WorkFlowTaskService,
    private projectSectionService: ProjectSectionService,
  ) {
    this.mit = this.globalService.mit;
  }

  @HostListener('window:visibilitychange')
  handleVisibilityChange() {
    this.getSummary();
  }

  getSummary() {
    this.workFlowTaskService
      .getTaskSummary()
      .subscribe((res: WorkFlowTaskSummary[]) => {
        this.count = 0;
        for (const item of res) {
          if (
            item.type === WorkFlowTaskToDoType.DONE ||
            item.type === WorkFlowTaskToDoType.READ ||
            item.type === WorkFlowTaskToDoType.WAITING ||
            item.type === WorkFlowTaskToDoType.IN_PROGRESS
          ) {
            continue;
          }
          this.count += +item.waitNum!;
        }
      });
  }

  private getUserInfo(info: LoginInfo) {
    zip(
      this.staffUserService.findById(info.uid!),
      this.projectSectionService.findAll<ProjectSectionListRequest>({
        projectId: this.globalService.projectId,
      }),
    ).subscribe((responses: [User, ProjectSection[]]) => {
      const user = responses[0];
      this.globalService.hasBeam = false;

      let hasJG = false;

      const sectionIds: number[] = [];
      if (user.userPosts && user.userPosts.length > 0) {
        // this.postInfo = user.userPosts?.[0];
        for (const post of user.userPosts ?? []) {
          if (user.organizationType === OrganizationType.CONSTRUCTION) {
            if (post.postName?.includes('梁场')) {
              this.globalService.hasBeam = true;
            }
          }
          if (!sectionIds.includes(post.sectionId!)) {
            sectionIds.push(post.sectionId!);
          }
        }
      }

      for (const section of user.projectSections ?? []) {
        if (section.beamYardSectionTag && this.globalService.hasBeam) {
          sectionIds.push(section.sectionId!);
        }
        if (section.sectionType === OrganizationType.JG_CHECK) {
          hasJG = true;
        }
      }

      const refSectionIds: number[] = [...sectionIds];

      const sectionMap: { [key: string]: ProjectSection } = {};
      for (const section of responses[1]) {
        sectionMap[section.id!] = section;
        if (sectionIds.includes(section.id!)) {
          for (const refSection of section.projectSectionSections ?? []) {
            if (!refSectionIds.includes(refSection.refSectionId!)) {
              refSectionIds.push(refSection.refSectionId!);
            }
          }
        }
      }

      if (user.organizationType === OrganizationType.SUPERVISE) {
        user.projectSections = user.projectSections?.filter((item) =>
          refSectionIds.includes(item.sectionId!),
        );
      }

      const addJgSectionIds: number[] = [];
      if (!hasJG) {
        const constructionSectionIds = user.projectSections
          ?.filter((item) => item.sectionType === OrganizationType.CONSTRUCTION)
          .map((item) => item.sectionId!);
        for (const section of responses[1]) {
          if (section.type !== OrganizationType.JG_CHECK) continue;
          for (const refSection of section.projectSectionSections ?? []) {
            if (
              refSection.refSectionType === OrganizationType.CONSTRUCTION &&
              constructionSectionIds?.includes(refSection.refSectionId!) &&
              !addJgSectionIds.includes(section.id!)
            ) {
              addJgSectionIds.push(section.id!);
            }
          }
        }
      }

      console.log('addJgSectionIds', addJgSectionIds);

      if (addJgSectionIds.length > 0) {
        for (const section of responses[1]) {
          if (addJgSectionIds.includes(section.id!)) {
            user.projectSections?.push({
              beamYardSectionTag: false,
              sectionId: section.id!,
              sectionType: section.type,
              sectionName: section.name,
              refSectionIds:
                section.projectSectionSections?.map(
                  (item) => item.refSectionId!,
                ) ?? [],
            });
          }
        }
      }

      for (const section of user.projectSections ?? []) {
        if (sectionMap[section.sectionId!]) {
          section.stage = sectionMap[section.sectionId!].stage;
        }
      }

      this.globalService.userInfo = user;
      this.userInfo = this.globalService.userInfo;
    });
  }

  onOpen(index: number) {
    this.openIndex = index;
  }

  private prepareMenu() {
    this.omMenuService.getUserMenus().subscribe((res: Menu[]) => {
      const newVer = Md5.hashStr(JSON.stringify(res));
      if (this.globalService.auditVersion !== newVer) {
        const auditMenuMap: { [key: string]: MenuAudit } = {};
        const menuList: {
          title: string;
          icon?: string;
          open: boolean;
          children: { title: string; url: string }[];
        }[] = [];
        for (const menu of res) {
          const parent: {
            title: string;
            icon?: string;
            open: boolean;
            children: { title: string; url: string }[];
          } = {
            title: menu.name!,
            icon: menu.icon,
            open: false,
            children: [],
          };
          for (const child of menu.child ?? []) {
            const url =
              child.type === MenuType.FORM
                ? `${child.url}/list/${child.id}`
                : child.url!;
            parent.children.push({
              title: child.name!,
              url,
            });
            if (child.menuAudits) {
              for (const audit of child.menuAudits) {
                auditMenuMap[audit.menuId!] = audit;
                this.auditUrlMap[url] = audit;
              }
            }
          }
          menuList.push(parent);
        }
        this.globalService.auditVersion = newVer;
        this.globalService.menuIdAuditsMap = auditMenuMap;
        this.globalService.urlAuditMap = this.auditUrlMap;
        this.globalService.menuList = menuList;
        this.fullMenuList = menuList;
      } else {
        this.auditUrlMap = this.globalService.urlAuditMap!;
        this.fullMenuList = this.globalService.menuList;
      }
      this.events.broadcast(EventType.AuditChange);
    });
  }

  ngOnInit() {
    this.getUserInfo(this.globalService.loginInfo!);
    this.prepareWbsTree();
    this.prepareMenu();
    this.getSummary();
  }

  resetSearchConfig(url: string) {
    if (url.indexOf('http://') === 0 || url.indexOf('https://') === 0) {
      window.open(url, '_blank');
      return;
    }
    this.globalService.resetSearchConfig();
  }

  private prepareWbsTree() {
    this.projectSectionItemService
      .tree({
        projectId: this.globalService.projectId,
        type: ProjectItemType.SECTION,
        // sectionId: 1000,
      })
      .subscribe((response: ProjectSectionItem) => {
        const newVer = Md5.hashStr(JSON.stringify(response));
        if (this.globalService.wbsTreeRootVersion !== newVer) {
          this.globalService.wbsTreeRootVersion = newVer;
          this.globalService.setWbsTreeRoot(response);
          this.events.broadcast(EventType.WbsChangeEvent);
        }
        this.projectSectionItemService
          .tree({
            projectId: this.globalService.projectId,
            type: ProjectItemType.FX,
          })
          .subscribe((response: ProjectSectionItem) => {
            const newVer = Md5.hashStr(JSON.stringify(response));
            if (this.globalService.wbsTitleTreeVersion !== newVer) {
              this.globalService.wbsTitleTreeVersion = newVer;
              this.globalService.setWbsTitleTree(response);
              this.events.broadcast(EventType.WbsTitleChangeEvent);
            }
          });
      });
  }

  getIconByName(name: string) {
    if (name === '工程施工') {
      return 'security-scan';
    }
    if (name === '工程办公') {
      return 'form';
    }
    if (name === '工程监理') {
      return 'alert';
    }

    return '';
  }

  getPrefixByName(name: string) {
    if (name === '工程施工') {
      return '/construction';
    }
    if (name === '工程办公') {
      return '/paperwork';
    }
    if (name === '工程监理') {
      return '/supervision';
    }

    return '/custom';
  }

  logout() {
    this.globalService.logout();
  }

  home() {
    this.router.navigateByUrl('/home');
  }
  homePage() {
    window.open('http://104.hzsksc.com:9191/homePage');
  }
}
